// extracted by mini-css-extract-plugin
module.exports = {"root":"gallery_root__i4Mw2","item":"gallery_item__QKLL0"};